<template>
  <nav class="w-full bg-sky-950 overflow-hidden sticky top-0 nav-shell">
    <div class="nav-shell-inner flex flex-col">
      <LoadingNavCompany v-if="loading" />
      <div class="flex py-2 h-[3.5rem] px-4 bg-sky-950" v-else>
        <div
          class="col-span-1 bg-sky-950 h-11 w-11 flex items-center justify-center rounded-full overflow-hidden flex-shrink-0">
          <div class="h-11 w-11 flex items-center justify-center flex-shrink-0">
            <img src="/img/profiles/default.png" v-if="!dataCompany.logo" alt="" />
            <img :src="buildApiResourceUrl(dataCompany.logo)" v-else alt=""
              @error="clearBrokenCompanyLogo" />
          </div>
        </div>
        <div class="col-span-11 text-white font-bold ml-2 mt-0 mb-0 small-hidden uppercase flex-wrap md:flex-nowrap">
          <span class="truncate overflow-hidden w-[150px] block">{{
            dataCompany.company
          }}</span>
          <span
            class="flex items-center gap-1 text-[13px] bg-sky-900 w-[150px] truncate overflow-hidden text-orange-400 font-semibold px-2 rounded-lg">
            <span class="w-2 h-2 rounded-full bg-green-400 block animate-pulse"></span>
            {{ dataCompany.store }}
          </span>
        </div>
      </div>
      <div class="flex-1 overflow-y-auto scroll-nav pt-5">
        <ul class="text-blue-100 text-sm" @click="toggleMenu">
          <li>
            <router-link to="/"
              class="bg-transparent hover:bg-sky-900 transition-colors flex py-3 px-4 items-center small-center">
              <font-awesome-icon icon="fa-solid fa-gauge" class="w-5 h-5" />
              <span class="ml-2 small-hidden"> Dashboard </span>
            </router-link>
          </li>
          <GetSystemModules />
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import GetSystemModules from "@/components/SystemModules/GetSystemModules.vue";
import LoadingNavCompany from "@/components/Loadings/LoadingNavCompany.vue";
import { onMounted, ref } from "vue";
import axios from "../../api";
import { errorActions } from "@/alerts";
import { clearStoredSession, getStoredAccessData, hasValidSession } from "@/publicjs/authSession";
import { buildApiResourceUrl } from "@/publicjs/resourceUrl";
export default {
  name: "NavComponent",
  components: {
    GetSystemModules,
    LoadingNavCompany,
  },
  setup() {
    const loading = ref(true);
    const dataCompany = ref({
      company: "",
      store: "",
      logo: null,
    });
    onMounted(async () => {
      loading.value = true;
      const dataUser = getStoredAccessData();

      if (!dataUser || !hasValidSession() || !dataUser?.user?.store) {
        loading.value = false;
        return;
      }

      try {
        const responseStore = await axios
          .get("sucursales/" + dataUser.user.store)
          .catch((error) => {
            errorActions(error);
          });
        if (!responseStore?.data) {
          loading.value = false;
          return;
        }
        if (responseStore.data.status === "Expired token") {
          clearStoredSession();
          window.location.href = "/login";
          return;
        }
        const responseCompany = await axios
          .get("empresa/" + responseStore.data.idempresa)
          .catch((error) => {
            errorActions(error);
          });
        if (!responseCompany?.data) {
          loading.value = false;
          return;
        }
        dataCompany.value.store = await responseStore.data.razon_social;
        dataCompany.value.company = await responseCompany.data.razon_social;
        dataCompany.value.logo = await responseCompany.data.logo;
      } catch (error) {
        errorActions(error);
      }

      loading.value = false;
    });

    const toggleMenu = (e) => {
      const toggle = e.target.closest(".toggle");

      if (!toggle) {
        return;
      }

      const navList = e.currentTarget;
      const subMenu = toggle.nextElementSibling;

      if (!subMenu || !subMenu.classList.contains("sub-menu")) {
        return;
      }

      const shouldOpen = !toggle.classList.contains("active");

      navList.querySelectorAll(".toggle.active").forEach((item) => {
        if (item !== toggle) {
          item.classList.remove("active");
        }
      });

      navList.querySelectorAll(".sub-menu.active").forEach((item) => {
        if (item !== subMenu) {
          item.classList.remove("active");
        }
      });

      toggle.classList.toggle("active", shouldOpen);
      subMenu.classList.toggle("active", shouldOpen);
    };

    const clearBrokenCompanyLogo = () => {
      dataCompany.value.logo = null;
    };

    return {
      toggleMenu,
      loading,
      dataCompany,
      buildApiResourceUrl,
      clearBrokenCompanyLogo,
    };
  },
};
</script>

<style scoped>
.nav-shell {
  height: var(--app-height, 100dvh);
  min-height: var(--app-height, 100dvh);
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
}

.nav-shell-inner {
  height: 100%;
}

.scroll-nav::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: rgba(0, 0, 0, 0);
  border-radius: 10px;
}

.scroll-nav::-webkit-scrollbar-thumb {
  border-radius: 10px;
  /* box-shadow: inset 0 0 6px var(--purple); */
  background-color: rgba(0, 0, 0, 0.068);
}

.scroll-nav::-webkit-scrollbar-track {
  background-color: transparent;
}

.scroll-nav::-webkit-scrollbar-thumb:hover,
.scroll-nav::-webkit-scrollbar-thumb:active {
  background: #93c5fd;
}

.truncate {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
